import { GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { hasTouchCapability } from '~/lib/utils/touch_detection';
import { rootPath } from '~/lib/utils/path_helpers/routes';
import logo from '../../../../views/shared/_logo.svg?raw';
export default {
    name: 'BrandLogo',
    logo,
    i18n: {
        homepage: __('Homepage')
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        SafeHtml
    },
    props: {
        logoUrl: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        homepageTooltip () {
            return hasTouchCapability() ? null : this.$options.i18n.homepage;
        },
        rootPath () {
            return rootPath({
                organizationPath: null
            });
        }
    }
};
